// ─────────────────────────────────────────────────────────────────────────────
// config.js  –  Central API configuration for VirtualKalvi
//
// ✅ Only this file needs to change if your server URL or API key changes.
// ✅ All components import API_HEADERS from here.
// ✅ Full API URLs (with query params) are built in Home.js and passed
//    via navigate state — NOT built inside individual slide components.
// ─────────────────────────────────────────────────────────────────────────────

export const BASE_API_URL = "https://api.virtualkalvi.com"; // your server base URL

export const API_KEY = "lathesh111430062005101819751979";   // your API key

// Pass this as headers in every fetch() call
export const API_HEADERS = {
  "Content-Type": "application/json",
  "X-API-Key": API_KEY,
};

// ─────────────────────────────────────────────────────────────────────────────
// API endpoint base paths — without query params.
// In Home.js, append your query params to build the full URL.
//
// Example in Home.js:
//   const url = `${API_ENDPOINTS.vkPicture}?grade_level=Tamil Learning`;
//   navigate("/tamil-slide", { state: { apiUrl: url } });
// ─────────────────────────────────────────────────────────────────────────────
export const API_ENDPOINTS = {
  vkPicture:    `${BASE_API_URL}/vkpicture`,
  twoMarkSlide: `${BASE_API_URL}/vktwomark`,
  // add more endpoints here as needed
};
